import React, { useContext, useEffect, useState } from "react";
import { AiOutlineTeam, AiOutlineHome } from "react-icons/ai";
import { BsRobot } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaMoneyBillTrendUp, FaTags } from "react-icons/fa6";
import { IoIosSend } from "react-icons/io";
import { MdPayment, MdPayments } from "react-icons/md";
import { ThemeContext } from "../../../contexts/themeConfig";
import NavLinks from "../../Prompt/NavLink";
import { getUserRole, getUserTeamAccessStatus } from "../../../Utility/service";
import UsersSvg from "../../common/UsersSvg";
import { GrTasks } from "react-icons/gr";
import { IoBarChartOutline, IoPricetagsOutline } from "react-icons/io5";
import { RiMoneyDollarBoxLine } from "react-icons/ri";
import { LuCircleDollarSign, LuSend } from "react-icons/lu";

const AdminNavLinks = () => {
  const { theme } = useContext(ThemeContext);
  const checkAccess = getUserTeamAccessStatus();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1020);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div>
      {isMobile && (
        <NavLinks
          svg={
            <AiOutlineHome
              size={22}
              style={{ color: theme === "light" ? "#000" : "#fff" }}
            />
          }
          text="Home"
          link="/chat"
        />
      )}
      <NavLinks
        svg={<CgProfile size={22} />}
        text="My Profile"
        link="/profile"
        id="my-profile-ad-navlink"
      />

      <NavLinks
        svg={
          <UsersSvg />
        }
        text="Users"
        link="/allUsers"
        id="users-ad-navlink"
      />

      <NavLinks
          svg={
            <IoBarChartOutline
              size={22}
              style={{ color: theme === "light" ? "#000" : "#fff" }}
            />

          }
          text="Usage"
          link="/trackUsageList"
          id="usage-sa-navlink"
        />

      <NavLinks
        svg={
          <AiOutlineTeam
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Departments"
        link="/allTeams"
        id="departments-ad-navlink"
      />


      <NavLinks
        svg={
          <BsRobot
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Agents"
        link="/allAssistantsList"
        id="agents-ad-navlink"
      />



      {/* <NavLinks
        svg={
          <MdPayment
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Upgrade Plan"
        link="/pricing"
        id="upgrade-plan-ad-navlink"
      /> */}
{/* 
      <NavLinks
        svg={
          <RiMoneyDollarBoxLine
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Billing"
        link="/billing"
        id="billing-ad-navlink"
      /> */}

      {/* <NavLinks
        svg={
          <LuSend
            size={22}
            style={{ color: theme === "light" ? "#000" : "#fff" }}
          />
        }
        text="Invite a friend"
        link="/invitation"
        id="invite-a-friend-ad-navlink"
      /> */}
       <NavLinks
          svg={
            <LuCircleDollarSign
              size={22}
              style={{ color: theme === "light" ? "#000" : "#fff" }}
            />
          }
          text="Subscriptions"
          id="subscriptions-ad-navlink"
          link="/subscriptions"
        />
    </div>
  );
};

export default AdminNavLinks;
